import { useState } from 'react';
import { BASE_URL } from '../utility/constants';
import { axiosInstance } from '../services/axiosConfig';

const useFormLibraryUpdate = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const updateFormLibrary = async ({ id, data }) => {
    setIsLoading(true);
    setResponse(null);
    setError(null);
    try {
      const res = await axiosInstance.put(`${BASE_URL}v1/form-library/${id}`, data);
      setResponse(res.data);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setResponse(null);
    setError(null);
    setIsLoading(false);
  };

  return { response, error, isLoading, updateFormLibrary, reset };
};

export default useFormLibraryUpdate; 